import { Download, Loader2 } from "lucide-react";
import type { FC } from "react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface CSVExportButtonProps {
  onClick: () => void;
  isExporting: boolean;
  className?: string;
  tooltipText?: string;
  disabled?: boolean;
}

/**
 * CSV Export Button
 */
export const CSVExportButton: FC<CSVExportButtonProps> = ({
  onClick,
  isExporting,
  className,
  tooltipText = "Export as CSV",
  disabled = false,
}) => {
  const buttonContent = (
    <>
      {isExporting ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Download className="h-4 w-4" />
      )}
    </>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          data-testid="csv-export-button"
          variant="outline"
          size="icon"
          onClick={onClick}
          disabled={isExporting || disabled}
          className={cn("h-8 w-8", className)}
        >
          {buttonContent}
        </Button>
      </TooltipTrigger>
      <TooltipContent className="max-w-[20rem]">
        <p>{tooltipText}</p>
      </TooltipContent>
    </Tooltip>
  );
};
